var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c("div", { staticClass: "row notification-container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-8 col-sm-7 col-md-4 mt-5" },
            [
              _c(
                "router-link",
                {
                  staticClass: "sub-heading",
                  attrs: { to: "/layout/launchpad" },
                },
                [
                  _c("i", { staticClass: "fa fa-angle-left" }),
                  _vm._v("System Notifications List "),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-4 col-sm-5 col-md-4 add-btn-container" },
            [
              _c(
                "a",
                {
                  staticClass: "btn emergo-green-button add-btn",
                  attrs: { href: "javascript:void(0);" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.openSystemNotification.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "glyphicon glyphicon-plus cursor-pointer",
                  }),
                  _vm._v(" Add "),
                  _c("span", { staticClass: "hidden-xs" }, [
                    _vm._v("New Notification"),
                  ]),
                ]
              ),
            ]
          ),
          _c("div", { staticClass: "col-xs-12 mt-30" }, [
            _c("div", { staticClass: "col-xs-12 p-0" }, [
              _vm.notificationsList
                ? _c(
                    "table",
                    {
                      staticClass: "table",
                      attrs: { id: "notificationDataList" },
                    },
                    [
                      _vm._m(0),
                      _vm.notificationsList && _vm.notificationsList.length
                        ? _c(
                            "tbody",
                            _vm._l(
                              _vm.notificationsList,
                              function (notification, index) {
                                return _c("tr", { key: index }, [
                                  _c("td", { staticClass: "center wd_edit" }, [
                                    _vm.showIcon(notification.end_date)
                                      ? _c("span", {
                                          staticClass:
                                            "glyphicon glyphicon-pencil cursor-pointer icon edit_color",
                                          on: {
                                            click: function ($event) {
                                              return _vm.editNotification(
                                                notification
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]),
                                  _c("td", { staticClass: "wd_type" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getBannerTypeName(
                                          notification.banner_type_id
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    { staticClass: "wd_start hidden-xs" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date")(
                                            notification.start_date
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "wd_end hidden-xs" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date")(notification.end_date)
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "wd_header notification-description-ellipsis",
                                    },
                                    [_vm._v(_vm._s(notification.header))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "wd_message notification-description-ellipsis",
                                    },
                                    [_vm._v(_vm._s(notification.message))]
                                  ),
                                ])
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.getAllSuccess && !_vm.notificationsList.length
                ? _c("h2", { staticClass: "center" }, [
                    _vm._v("No notification(s) found"),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "wd_edit" }),
        _c("th", { staticClass: "wd_type" }, [_vm._v("Type")]),
        _c("th", { staticClass: "hidden-xs wd_start" }, [
          _vm._v("Start Date and Time (CST)"),
        ]),
        _c("th", { staticClass: "hidden-xs wd_end" }, [
          _vm._v("End Date and Time (CST)"),
        ]),
        _c("th", { staticClass: "wd_header" }, [_vm._v("Header")]),
        _c("th", { staticClass: "wd_message" }, [_vm._v("Message")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }